export default "__VITE_ASSET__BNG3FleN__"